(function () {
  function getFooter() {
    const drawer = document.querySelector("#facets-drawer");
    if (!drawer) return null;
    return drawer.querySelector('div[slot="footer"]');
  }

  function hasFilters() {
    const url = new URL(window.location.href);
    for (const k of url.searchParams.keys()) {
      if (k.startsWith("filter.")) return true;
    }
    return false;
  }

  function buildClearAllUrl() {
    const url = new URL(window.location.href);
    const rebuilt = new URLSearchParams();

    // mantém q e sort_by (se quiseres limpar também sort_by, diz-me)
    const keepKeys = new Set(["q", "sort_by"]);

    for (const [k, v] of url.searchParams.entries()) {
      if (k.startsWith("filter.")) continue;
      if (k === "page") continue;
      if (keepKeys.has(k)) rebuilt.append(k, v);
    }

    url.search = rebuilt.toString();
    return url.toString();
  }

  function ensureClearAll(footer) {
    // já existe?
    if (footer.querySelector(".rh-clear-all")) return;

    // encontra o botão View results
    const viewBtn = Array.from(footer.querySelectorAll("button"))
      .find((b) => (b.textContent || "").trim().toLowerCase().includes("view results"));

    if (!viewBtn) return;

    // wrapper que fecha o dialog (igual ao View results)
    const wrap = document.createElement("dialog-close-button");
    wrap.className = "contents rh-clear-wrap";

    const a = document.createElement("a");
    a.className = "button w-full rh-clear-all";
    a.setAttribute("role", "button");
    a.textContent = "Clear all";

    wrap.appendChild(a);

    // mete antes do dialog-close-button existente
    footer.insertBefore(wrap, footer.firstChild);

    // estado + click
    function refresh() {
      const active = hasFilters();
      a.href = buildClearAllUrl();
      a.classList.toggle("is-disabled", !active);
      a.setAttribute("aria-disabled", active ? "false" : "true");
      a.tabIndex = active ? 0 : -1;
    }

    a.addEventListener("click", (e) => {
      e.preventDefault();
      if (a.classList.contains("is-disabled")) return;
      window.location.href = a.href;
    });

    refresh();
    // revalida quando o URL muda via filtros
    window.addEventListener("popstate", refresh);
    document.addEventListener("change", (e) => {
      if (e.target && e.target.closest("#facets-drawer")) setTimeout(refresh, 120);
    });
  }

  function apply() {
    const footer = getFooter();
    if (!footer) return;
    ensureClearAll(footer);
  }

  // tenta já
  document.addEventListener("DOMContentLoaded", apply);
  window.addEventListener("load", apply);

  // observa o DOM até o footer aparecer (Prestige re-renderiza)
  const obs = new MutationObserver(apply);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();